/** @desc 获取url参数 */
export const getQueryString = (name, url) => {
  const reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i');
  let r;
  try {
    if (url) {
      r = new URL(url).search.substr(1).match(reg);
    } else {
      r = window.location.search.substr(1).match(reg);
    }
    if (r != null) return unescape(r[2]);
    return null;
  } catch (error) {
    return null;
  }
};

/**
 * @desc sleep延时方法
 * @param {Number} timestamp 延时时长
 * @return {Promise<void>} await sleep(1000)
 */
export const sleep = (timestamp) =>
  new Promise((resolve) => {
    setTimeout(() => {
      resolve();
    }, timestamp);
  });

export const isH5 = document.body.clientWidth <= 768;
